export default __webpack_public_path__ + "static/media/badge-dropin-icon.4c6a40fe.svg";